<template>
    <div class="chart-wrapper">
        <v-chart :forceFit="true" :height="height" :data="data" :scale="scale" :padding="padding">
          <v-tooltip
            itemTpl="<li><span style=&quot;background-color:{color};&quot; class=&quot;g2-tooltip-marker&quot;></span>{name}: {value}</li>"
          />
          <v-axis />
          <v-legend :position="position" marker="circle"/>
          <v-line
            position="x*value"
            :tooltip="tooltip"
            shape="smooth"
            :size="borderWidth"
            :v-style="style"
            :color="color"
          />
        </v-chart>
    </div>
</template>

<style lang="stylus" scoped>

</style>
<script>
import DataSet from '@antv/data-set'
import { cloneDeep } from 'lodash'

const circleColors = {
  '平均课堂表现': '#04C18B',
  '完成度': '#05A9FF',
  '注意力': '#FD7351',
  '课堂效率': '#FFC63B'
}

export default {
  data() {
    return {
      max: 100,
      first: true,
      data: [],
      scale: [{
        dataKey: 'x',
        type: 'time',
        tickInterval: 60 * 60 * 1000 * 24,
        mask: 'MMDD',
        range: [0, 1]
      },
      {
        dataKey: 'value',
        max: this.max,
        min: 0
      }],
      color: [
        'key',
        [
          'l (180) 0:rgba(0,200,130,1) 1:rgba(125,242,139,1)',
          'l (180) 0:rgba(31,172,245,1) 1:rgba(119,225,248,1)',
          'l (180) 0:rgba(253,115,81,1) 1:rgba(255,170,149,1)',
          'l (180) 0:rgba(255,182,5,1) 1:rgba(255,211,103,1)'
        ]
      ],
      tooltip: [
        'x*value*key',
        (x, value, key) => {
          return {
            name: key,
            color: circleColors[key],
            title: `123123`,
            value
          }
        }
      ],
      position: 'bottom',
      style: {
        shadowColor: 'l (270) 0:rgba(21, 146, 255, 0)',
        shadowOffsetX: 2,
        shadowOffsetY: 4
      }
    }
  },
  props: {
    sourceData: Array,
    titleMap: {
      type: Object,
      default: () => ({
        avgClassroomPerformance: 'avgClassroomPerformance',
        completeDegree: 'completeDegree',
        attention: 'attention',
        classroomEfficiency: 'classroomEfficiency'
      })
    },
    padding: {
      type: Array,
      default: () => ([40, 20, 60, 60])
    },
    height: {
      type: Number,
      default: 450
    },
    borderWidth: {
      type: Number,
      default: 2
    }
  },
  watch: {
    sourceData() {
      if (this.sourceData.length) {
        this.initChart()
      }
    }
  },
  computed: {
  },
  methods: {
    initChart () {
      // 防止不停更新this.sourceData导致init不停触发
      const sourceData = cloneDeep(this.sourceData)

      if (!sourceData.length) { return }
      const data = Array.isArray(sourceData) ? sourceData : [{ x: 0, avgClassroomPerformance: 0, completeDegree: 0, attention: 0, classroomEfficiency: 0 }]
      data.sort((a, b) => a.x - b.x)

      let max
      if (data[0] && data[0].avgClassroomPerformance && data[0].completeDegree && data[0].attention && data[0].classroomEfficiency) {
        max = Math.max(
          [...data].sort((a, b) => b.avgClassroomPerformance - a.avgClassroomPerformance)[0].avgClassroomPerformance,
          [...data].sort((a, b) => b.completeDegree - a.completeDegree)[0].completeDegree,
          [...data].sort((a, b) => b.attention - a.completeDegree)[0].attention,
          [...data].sort((a, b) => b.classroomEfficiency - a.completeDegree)[0].classroomEfficiency
        )
      }

      this.max = max || this.max

      const ds = new DataSet({
        state: {
          start: data[0].x,
          end: data[data.length - 1].x
        }
      })

      const dv = ds.createView().source(data)

      dv
        .transform({
          type: 'filter',
          callback: obj => {
            const date = obj.x
            return date <= ds.state.end && date >= ds.state.start
          }
        })
        .transform({
          type: 'map',
          callback: (row) => {
            const newRow = { ...row }
            newRow[this.titleMap.avgClassroomPerformance] = row.avgClassroomPerformance
            newRow[this.titleMap.completeDegree] = row.completeDegree
            newRow[this.titleMap.attention] = row.attention
            newRow[this.titleMap.classroomEfficiency] = row.classroomEfficiency
            return newRow
          }
        })
        .transform({
          type: 'fold',
          fields: [this.titleMap.avgClassroomPerformance, this.titleMap.completeDegree, this.titleMap.attention, this.titleMap.classroomEfficiency], // 展开字段集
          key: 'key', // key字段
          value: 'value' // value字段
        })
      // console.log(JSON.source(dv.rows))
      this.$data.data = dv
    }
  },
  mounted() {
    this.initChart()
  }
}
</script>
